import api from 'api';

export default function resizeWorker(workerId: string, slots: number) {
  return api.patch(`workers/${workerId}`, { json: { slots } });
}
